export const dummyData = {
    documentType: {
        '5': 'Authorization of Authorized Representative',
        '10': 'Authorization of Authorized Representative of Beneficial Owner',
        '7': 'Beneficial Ownership and Identity',
        '3': 'Commercial registry/Business Register',
        '4': 'Executed Letter of Authorization',
        '6': 'Name/Address/Date of Birth of Authorized Representative',
        '8': 'Name/Address of Beneficial Owner',
        '9': 'Name/Date/Address of Authorized Representative of Beneficial Owner',
        '11': 'Proof of Address (Individual/Company)',
        '2': 'Proof of Business/Business Address',
        '12': 'Proof of Identification (Individual/Company-Signatory)',
        '1': 'Proof of Identity',
    },
    supportedCountriesData: [
        { label: 'India', value: 'India' },
        { label: 'Afghanistan', value: 'Afghanistan' },
        { label: 'UK', value: 'UK' },
        { label: 'Australia', value: 'Australia' },

    ]
}